export const CLAIMR_CONTAINER_ID = 'CLAIMR_CONTAINER';

export const BETS: number[] = [50, 100, 200];
